import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams, } from "react-router-dom";
import { startGetCatServiciosGNP, startGetDetalleServicioVial } from "../../../../context/actions/gnpApiActions";
import CardPage from "../../../../layout/CardPage";
import { Datos } from "./Datos";

export const Catch = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { folioAsignacion } = useParams();

  //
  useEffect(() => {

    dispatch(startGetDetalleServicioVial(folioAsignacion))
    // depreciado
    //dispatch(startLoadServicio(folioAsignacion));

    // para selecciona que servicio es para sigsa
    dispatch(startGetCatServiciosGNP());
  }, [dispatch,folioAsignacion]);

  return (
    <CardPage
      titulo={`Confirmar Servicio`}
      tituloBoton="Regresar"
      accionBoton={() => history.push("/GnpApi")}
    >
      <Datos />
    </CardPage>
  );
};
